import { useMemo, useEffect } from 'react';

//* HOC's
import { withDataContext } from 'context';

//* Components
import Page from 'components/common/Page';
import PageBuilder from 'components/common/PageBuilder';
import LandingHeader from 'components/layouts/LandingHeader';
import LandingFooter from 'components/layouts/LandingFooter';
import VTB_BranchTableSection from 'components/pages/landing/VTB_BranchTableSection';

const pixels = {
	2: 'https://pixel.zprk.io/v5/pixel/WiBebUUUFP.gif?ssid=1&gdpr=add_gdpr_macro&consent=add_consent_macro&ut3=USA',
	3: 'https://pixel.zprk.io/v5/pixel/6iPgV7n9N5.gif?ssid=1&gdpr=add_gdpr_macro&consent=add_consent_macro&ut3=Germany',
	4: 'https://pixel.zprk.io/v5/pixel/KVNVRtX7V5.gif?ssid=1&gdpr=add_gdpr_macro&consent=add_consent_macro&ut3=France',
	5: 'https://pixel.zprk.io/v5/pixel/q2bGCDIHMf.gif?ssid=1&ut3=UAE',
};

const Landing = ({ singleLanding, pageParams, selectedLang }) => {
	const pageData = useMemo(() => singleLanding?.[pageParams.selectedSlug]?.[selectedLang], [singleLanding, pageParams, selectedLang]);

	//! Checks
	const isVTB = useMemo(() => pageData?.id == 1, [pageData]);

	useEffect(() => {
		if (pageData && pixels[pageData.id]) {
			const img = new Image();
			img.src = pixels[pageData.id];
			img.style.display = 'none';
			document.body.appendChild(img);
		}
	}, [pageData]);

	return pageData ? (
		<>
			<LandingHeader
				full_type={isVTB}
				title={pageData.title}
				image={pageData.banner}
			/>

			<Page meta={pageData.meta}>
				<PageBuilder
					pageId={pageData.id}
					components={pageData.components}
				/>

				{isVTB && <VTB_BranchTableSection />}
			</Page>

			<LandingFooter />
		</>
	) : null;
};

export default withDataContext(Landing, ['singleLanding']);
